/*
  Astral by Santi Accessibility Helper for Shopify — v1
  Add to: assets/astral-accessibility.js
*/

(function () {
  "use strict";

  var STORAGE_KEY = "astralShopifyAccessibilityPrefsV1";
  var root = document.documentElement;

  var CLASSES = [
    "astral-a11y-text-lg",
    "astral-a11y-text-xl",
    "astral-a11y-readable-font",
    "astral-a11y-underline-links",
    "astral-a11y-high-contrast",
    "astral-a11y-dark-readable",
    "astral-a11y-reduce-motion"
  ];

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn, { once: true });
  }

  function getPrefs() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
    } catch (error) {
      return {};
    }
  }

  function savePrefs(prefs) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
    } catch (error) {
      /* Preferences are optional. The widget still works if storage is blocked. */
    }
  }

  function syncPressedStates(prefs) {
    document.querySelectorAll("[data-astral-a11y]").forEach(function (button) {
      var className = button.getAttribute("data-astral-a11y");
      button.setAttribute("aria-pressed", prefs[className] ? "true" : "false");
    });
  }

  function applyPrefs() {
    var prefs = getPrefs();

    CLASSES.forEach(function (className) {
      root.classList.toggle(className, Boolean(prefs[className]));
      if (document.body) {
        document.body.classList.toggle(className, Boolean(prefs[className]));
      }
    });

    syncPressedStates(prefs);
  }

  function announce(message) {
    var status = document.getElementById("astral-a11y-status");
    if (!status) return;

    status.textContent = "";
    window.setTimeout(function () {
      status.textContent = message;
    }, 20);
  }

  function togglePref(className, label) {
    var prefs = getPrefs();

    if (className === "astral-a11y-text-lg") {
      prefs["astral-a11y-text-xl"] = false;
    }

    if (className === "astral-a11y-text-xl") {
      prefs["astral-a11y-text-lg"] = false;
    }

    if (className === "astral-a11y-high-contrast") {
      prefs["astral-a11y-dark-readable"] = false;
    }

    if (className === "astral-a11y-dark-readable") {
      prefs["astral-a11y-high-contrast"] = false;
    }

    prefs[className] = !prefs[className];
    savePrefs(prefs);
    applyPrefs();

    announce(
      (label || "Accessibility setting") +
        (prefs[className] ? " enabled" : " disabled")
    );
  }

  function getFocusable(container) {
    return Array.prototype.slice.call(
      container.querySelectorAll(
        'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (element) {
      return (
        !element.hidden &&
        element.getAttribute("aria-hidden") !== "true" &&
        (element.offsetWidth > 0 ||
          element.offsetHeight > 0 ||
          element === document.activeElement)
      );
    });
  }

  function trapFocus(event, container) {
    if (event.key !== "Tab") return;

    var focusable = getFocusable(container);

    if (!focusable.length) {
      event.preventDefault();
      container.focus();
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function ensureMainContentTarget() {
    var skipLink = document.querySelector(".astral-skip-link");

    var main =
      document.getElementById("MainContent") ||
      document.querySelector("main") ||
      document.querySelector('[role="main"]');

    if (!main || !skipLink) return;

    if (!main.id) {
      main.id = "MainContent";
    }

    if (!main.hasAttribute("tabindex")) {
      main.setAttribute("tabindex", "-1");
    }

    skipLink.setAttribute("href", "#" + main.id);

    skipLink.addEventListener("click", function () {
      window.setTimeout(function () {
        try {
          main.focus({ preventScroll: true });
        } catch (error) {
          main.focus();
        }
      }, 0);
    });
  }

  function initPanel() {
    var widget = document.getElementById("astral-a11y-widget");
    var panel = document.getElementById("astral-a11y-panel");

    var toggle = widget
      ? widget.querySelector(".astral-a11y-toggle")
      : null;

    var reset = document.getElementById("astral-a11y-reset");

    if (!widget || !panel || !toggle) return;

    function setOpen(open, restoreFocus) {
      panel.hidden = !open;

      toggle.setAttribute("aria-expanded", String(open));

      toggle.setAttribute(
        "aria-label",
        open
          ? "Close accessibility options"
          : "Open accessibility options"
      );

      if (open) {
        var first = panel.querySelector("button");

        if (first) {
          first.focus();
        }
      } else if (restoreFocus) {
        toggle.focus();
      }
    }

    toggle.addEventListener("click", function () {
      setOpen(panel.hidden, false);
    });

    document
      .querySelectorAll("[data-astral-a11y]")
      .forEach(function (button) {
        button.addEventListener("click", function () {
          togglePref(
            button.getAttribute("data-astral-a11y"),
            button.getAttribute("data-astral-label") ||
              button.textContent.trim()
          );
        });
      });

    if (reset) {
      reset.addEventListener("click", function () {
        try {
          localStorage.removeItem(STORAGE_KEY);
        } catch (error) {}

        applyPrefs();
        announce("Accessibility settings reset");
      });
    }

    document.addEventListener("pointerdown", function (event) {
      if (!panel.hidden && !widget.contains(event.target)) {
        setOpen(false, false);
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && !panel.hidden) {
        event.preventDefault();
        setOpen(false, true);
      }
    });
  }

  function setPageInert(modal, inert) {
    if (!document.body || !("inert" in HTMLElement.prototype)) {
      return;
    }

    Array.prototype.forEach.call(
      document.body.children,
      function (child) {
        if (
          child === modal ||
          child.tagName === "SCRIPT" ||
          child.tagName === "STYLE"
        ) {
          return;
        }

        if (inert) {
          if (!child.inert) {
            child.inert = true;
            child.setAttribute(
              "data-astral-a11y-inert",
              "true"
            );
          }
        } else if (
          child.getAttribute(
            "data-astral-a11y-inert"
          ) === "true"
        ) {
          child.inert = false;
          child.removeAttribute(
            "data-astral-a11y-inert"
          );
        }
      }
    );
  }

  function initStatementModal() {
    var openButton = document.getElementById(
      "astral-accessibility-statement-open"
    );

    var modal = document.getElementById(
      "astral-accessibility-statement"
    );

    var modalCard = modal
      ? modal.querySelector(".astral-a11y-modal-card")
      : null;

    var closeButtons = modal
      ? modal.querySelectorAll(
          "[data-astral-a11y-close]"
        )
      : [];

    var lastFocused = null;

    if (!openButton || !modal || !modalCard) {
      return;
    }

    function openModal() {
      lastFocused = document.activeElement;

      modal.hidden = false;

      document.body.classList.add(
        "astral-a11y-lock"
      );

      openButton.setAttribute(
        "aria-expanded",
        "true"
      );

      setPageInert(modal, true);

      window.setTimeout(function () {
        var close = modal.querySelector(
          ".astral-a11y-modal-close"
        );

        if (close) {
          close.focus();
        } else {
          modalCard.focus();
        }
      }, 0);
    }

    function closeModal() {
      if (modal.hidden) return;

      setPageInert(modal, false);

      modal.hidden = true;

      document.body.classList.remove(
        "astral-a11y-lock"
      );

      openButton.setAttribute(
        "aria-expanded",
        "false"
      );

      if (
        lastFocused &&
        typeof lastFocused.focus === "function"
      ) {
        lastFocused.focus();
      }
    }

    openButton.setAttribute(
      "aria-haspopup",
      "dialog"
    );

    openButton.setAttribute(
      "aria-controls",
      "astral-accessibility-statement"
    );

    openButton.setAttribute(
      "aria-expanded",
      "false"
    );

    openButton.addEventListener(
      "click",
      openModal
    );

    closeButtons.forEach(function (element) {
      element.addEventListener(
        "click",
        closeModal
      );
    });

    document.addEventListener(
      "keydown",
      function (event) {
        if (modal.hidden) return;

        if (event.key === "Escape") {
          event.preventDefault();
          closeModal();
          return;
        }

        trapFocus(event, modalCard);
      }
    );
  }

  function hardenExternalLinks() {
    document
      .querySelectorAll('a[target="_blank"]')
      .forEach(function (link) {
        var rel = (
          link.getAttribute("rel") || ""
        )
          .split(/\s+/)
          .filter(Boolean);

        if (rel.indexOf("noopener") === -1) {
          rel.push("noopener");
        }

        if (rel.indexOf("noreferrer") === -1) {
          rel.push("noreferrer");
        }

        link.setAttribute(
          "rel",
          rel.join(" ")
        );
      });
  }

  function markPotentialAccessibilityIssues() {
    /*
      Deliberately do NOT auto-fill missing image alt text
      or form labels.

      Guessing those values can hide meaningful content from
      assistive technology.

      These data attributes are inert and make manual QA
      easier in DevTools.
    */

    document
      .querySelectorAll("img:not([alt])")
      .forEach(function (img) {
        img.setAttribute(
          "data-astral-a11y-review",
          "missing-alt"
        );
      });

    document
      .querySelectorAll("iframe:not([title])")
      .forEach(function (frame) {
        frame.setAttribute(
          "data-astral-a11y-review",
          "missing-title"
        );
      });
  }

  function observeDynamicContent() {
    if (
      !("MutationObserver" in window) ||
      !document.body
    ) {
      return;
    }

    var scheduled = false;

    var observer = new MutationObserver(
      function () {
        if (scheduled) return;

        scheduled = true;

        window.requestAnimationFrame(
          function () {
            scheduled = false;

            hardenExternalLinks();
            markPotentialAccessibilityIssues();
          }
        );
      }
    );

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  ready(function () {
    ensureMainContentTarget();
    initPanel();
    initStatementModal();
    hardenExternalLinks();
    markPotentialAccessibilityIssues();
    applyPrefs();
    observeDynamicContent();
  });
})();